import React from "react";
import './buttonglass.css'
import { Box } from "@chakra-ui/react";
function Buttonglass(props) {





  return (
    <>
  <Box className="btn"  _before={{
    background: `${props.color}`,
    boxShadow: `0 0 5px ${props.color}, 0 0 15px ${props.color}, 0 0 30px #ff1f71,0 0 60px ${props.color}`
}}

_after={{
  background: `${props.color}`,
  boxShadow: `0 0 5px ${props.color}, 0 0 15px ${props.color}, 0 0 30px ${props.color},0 0 60px ${props.color}`
}}
 ><a >{props.children}</a></Box>    




    </>
  );
}

export default Buttonglass;




